/**
 * Wielka litera na początku komunikatu z API.
 *
 * Wiele odmów z serwera zaczyna się małą literą, bo bywają wklejane w dłuższe
 * zdania („… — publikacja wymaga …”), a pokazują się też samodzielnie, jako
 * powiadomienie albo komunikat pod formularzem (lista komunikatów z
 * 01.10.2026, „Problemy poza brzmieniem”). Teksty API zostają bez zmian —
 * poprawiamy tylko zapis przy wyświetlaniu, w obsłudze błędów.
 *
 * Pierwsze słowo, które wygląda na identyfikator (`carId`, `timocom/…`,
 * `shipment[0]`), zostaje nietknięte — „CarId” byłoby gorsze niż „carId”.
 */
export function capitalizeFirst(text: string): string {
  const m = /^(\s*)(\S)(\S*)/.exec(text);
  if (!m) return text;
  const [, lead, first, rest] = m;
  // Mała litera to znak, który ma osobną wielką postać — także ą, ł, ż, ü.
  const isLower = (c: string) => c !== c.toLocaleUpperCase('pl-PL');
  const isUpper = (c: string) => c !== c.toLocaleLowerCase('pl-PL');
  if (!isLower(first)) return text;
  if (rest.split('').some((c) => isUpper(c) || /[\d_./@<[\]]/.test(c))) return text;
  return lead + first.toLocaleUpperCase('pl-PL') + text.slice(lead.length + first.length);
}

/**
 * Błąd z poprawionym komunikatem — dla klienta HTTP react-admina, który
 * pokazuje `message` błędu w powiadomieniu. Klucze słownika react-admina
 * (`ra.…`) zostają, bo tłumaczy je dopiero powiadomienie.
 */
export function capitalizeErrorMessage<T>(error: T): T {
  if (error instanceof Error && !error.message.startsWith('ra.')) {
    error.message = capitalizeFirst(error.message);
  }
  return error;
}
